import { Map } from 'immutable'
import {
  SET_MAX_REACH_PROCESSING,
  SET_MAX_REACH_DATA,
  SET_MAX_REACH_ERROR,
  CLEAR_MAX_REACH_DATA,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_MAX_REACH_PROCESSING:
      return state
        .setIn(['processing'], payload.processing)
        .delete(payload.campaignId)
        .deleteIn(['error', payload.campaignId])
    case SET_MAX_REACH_DATA:
      return state
        .setIn([payload.campaignId], parseInt(payload.data, 10))
        .setIn(['processing'], false)
    case SET_MAX_REACH_ERROR:
      return state
        .setIn(['error', payload.campaignId], payload.error.message)
        .setIn(['processing'], false)
    case CLEAR_MAX_REACH_DATA:
      return state.delete(payload.campaignId)
    default:
      return state
  }
}
